import { render, staticRenderFns } from "./SelectionBlocks.vue?vue&type=template&id=6c5867ba&scoped=true"
import script from "./SelectionBlocks.vue?vue&type=script&lang=js"
export * from "./SelectionBlocks.vue?vue&type=script&lang=js"
import style0 from "./SelectionBlocks.vue?vue&type=style&index=0&id=6c5867ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5867ba",
  null
  
)

export default component.exports